export enum Mode {
    Create  = 'Create',
    Update = 'Update',
    View = 'View'
}